export default "__VITE_ASSET__COGRXpZv__"